import type { Task } from "fhir/r5";

import { MobileTopSheet } from "@/components/common/MobileTopSheet";

import { useHeaderCollapse } from "./HeaderCollapseContext";
import { NotificationsPanelBody } from "./NotificationsPanelBody";

interface MobileNotificationsPanelProps {
  open: boolean;
  onClose: () => void;
  unreadCount: number;
  loading: boolean;
  accessType?: string | null;
  tasks: Task[];
  updatingById: Record<string, boolean>;
  onToggleReadStatus: (task: Task) => void;
  onAccessMedicalRecord: (task: Task) => void;
  onRespondQuestionnaire: (task: Task) => void;
}

export function MobileNotificationsPanel({
  open,
  onClose,
  unreadCount,
  loading,
  accessType,
  tasks,
  updatingById,
  onToggleReadStatus,
  onAccessMedicalRecord,
  onRespondQuestionnaire,
}: MobileNotificationsPanelProps) {
  const { mobileHeaderOffset } = useHeaderCollapse();

  return (
    <MobileTopSheet
      open={open}
      onClose={onClose}
      title="Notificações"
      hideHeader
      headerLayer
      size="large"
      topOffset={mobileHeaderOffset}
    >
      <NotificationsPanelBody
        unreadCount={unreadCount}
        loading={loading}
        accessType={accessType}
        tasks={tasks}
        updatingById={updatingById}
        closeHint="Toque fora para fechar"
        onToggleReadStatus={onToggleReadStatus}
        onAccessMedicalRecord={onAccessMedicalRecord}
        onRespondQuestionnaire={onRespondQuestionnaire}
        // Convite de teleconsultoria: fecha o painel ao entrar no atendimento.
        onRequestClose={onClose}
      />
    </MobileTopSheet>
  );
}
